var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.loading)?_c('nb-autocomplete',{attrs:{"label":_vm.answerBlockData.label,"options":_vm.options,"optional":!_vm.answerBlockData.is_required},on:{"search":_vm.fetchOptions},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }